<!-- Dialog -->
<div class="dialog show" role="dialog" aria-modal="true" aria-labelledby="promo-title" aria-describedby="promo-desc">
  <!-- Close button -->
  <button type="button" class="icon-btn close-btn" aria-label="Close dialog" (click)="closeDialog()">✕</button>

  <!-- Header with Background Image -->
  <header class="header">
    <img class="header-bg" src="../../../../assets/img/seepex_produkte_technologie_rotor-stator.jpg" alt="" aria-hidden="true" />
    <div class="header-overlay"></div>
    <div class="header-content">
      <h2 id="promo-title" class="title">{{ 'PROMOTIONAL_POPUP.HEADER_LABEL' | translate }}</h2>
      <div id="promo-desc" class="subtitle" [innerHTML]="'PROMOTIONAL_POPUP.HEADER_LABEL_HINT' | translate"></div>
    </div>
  </header>

  <!-- Two Column Layout for Sections -->
  <div class="sections-container">
    <!-- Condition Monitoring Section -->
    <section class="promo-section monitoring">
      <img class="section-bg" src="../../../../assets/img/Pump_Monitor_2021_NEU_800x618.jpg" alt="" aria-hidden="true" />
      <div class="section-overlay"></div>
      <div class="section-content">
        <div class="section-icon">
          <spx-icon name="computer"></spx-icon>
        </div>
        <h3 class="section-title">{{ 'PROMOTIONAL_POPUP.CONDITION_MONITORING.TITLE' | translate }}</h3>
        <ul class="benefits">
          <li>
            <span class="checkmark">✔</span>
            <span>{{ 'PROMOTIONAL_POPUP.CONDITION_MONITORING.BENEFIT_1' | translate }}</span>
          </li>
          <li>
            <span class="checkmark">✔</span>
            <span>{{ 'PROMOTIONAL_POPUP.CONDITION_MONITORING.BENEFIT_2' | translate }}</span>
          </li>
          <li>
            <span class="checkmark">✔</span>
            <span>{{ 'PROMOTIONAL_POPUP.CONDITION_MONITORING.BENEFIT_3' | translate }}</span>
          </li>
        </ul>
      </div>
    </section>

    <!-- CARE Section -->
    <section class="promo-section care">
      <img class="section-bg" src="../../../../assets/img/SCT_Disassembly.jpg" alt="" aria-hidden="true" />
      <div class="section-overlay"></div>
      <div class="section-content">
        <div class="section-icon">
          <spx-icon name="build"></spx-icon>
        </div>
        <h3 class="section-title">{{ 'PROMOTIONAL_POPUP.CARE.TITLE' | translate }}</h3>
        <ul class="benefits">
          <li>
            <span class="checkmark">✔</span>
            <span>{{ 'PROMOTIONAL_POPUP.CARE.BENEFIT_1' | translate }}</span>
          </li>
          <li>
            <span class="checkmark">✔</span>
            <span>{{ 'PROMOTIONAL_POPUP.CARE.BENEFIT_2' | translate }}</span>
          </li>
          <li>
            <span class="checkmark">✔</span>
            <span>{{ 'PROMOTIONAL_POPUP.CARE.BENEFIT_3' | translate }}</span>
          </li>
        </ul>
      </div>
    </section>
  </div>

  <!-- Footer CTA Text -->
  <div class="footer-cta">
    <p class="footer-cta-text">{{ 'PROMOTIONAL_POPUP.FOOTER_CTA' | translate }}</p>
  </div>
</div>
